<div class="trade box row operation-component">
  <div class="operation-control-container">
    <label class="widget-title">OPERACIÓN</label>
  </div>
  <div class="col-xs-12">
    <div class="operation" [class.disabled]="!operations"></div>
    <ul class="tabs square" *ngIf="!isUsaContract">
      <li [class.selected]="selectedTab === 0" (click)="changeView(0)">
        Capitales
      </li>
      <li [class.selected]="selectedTab === 1" (click)="changeView(1)">
        Fondos
      </li>
    </ul>
    <div class="content">
      <hb-trade-capitals
        *ngIf="selectedTab === 0 || isUsaContract"
        (changeOperationStatus)="changeOperationStatus('capital', $event)"
        (changeOrderType)="onChangeOrderType($event)"
        [operationStatus]="operationControl.capital"
        [inheritedOrder]="selectedOrder"
        [isGeolocationEnabled]="!(shouldRestrictTradeOperations$ | async)"
        [shouldNotifyGeolocationOnOperationAttempt]="
          shouldNotifyGeolocationOnOperationAttempt$ | async
        "
        [shouldStartLoaderOnOperationAttempt]="
          (shouldRestrictTradeOperations$ | async) &&
          !(shouldNotifyGeolocationOnOperationAttempt$ | async)
        "
        [isPositionMocked]="isPositionMocked$ | async"
      >
      </hb-trade-capitals>
      <hb-trade-funds
        *ngIf="selectedTab === 1 && !isUsaContract"
        (changeOperationStatus)="changeOperationStatus('funds', $event)"
        [operationStatus]="operationControl.funds"
        [isGeolocationEnabled]="!(shouldRestrictTradeOperations$ | async)"
        [shouldNotifyGeolocationOnOperationAttempt]="
          shouldNotifyGeolocationOnOperationAttempt
        "
        [shouldStartLoaderOnOperationAttempt]="
          shouldStartLoaderOnOperationAttempt
        "
        [isPositionMocked]="isPositionMocked$ | async"
      >
      </hb-trade-funds>
    </div>
  </div>
</div>
